import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_EXTRA_SMALL_OUTLINE_BUTTONS, FLAT_EXTRA_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatOutlineExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineExtraSmallButton} span={FLAT_EXTRA_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" outline color="primary" id="Tooltip-68" className="btn-square">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-68" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-outline-primary btn-xs</ToolTip>
          {FLAT_EXTRA_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} outline={true} size="xs"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatOutlineExtraSmallButtons;
